import "core-js/fn/promise";
import "core-js/fn/string/includes";
import "object-fit-polyfill";

type PolyfillTest = () => boolean;
type PolyfillLoader = () => Promise<any>;

interface IPolyfill {
    test: PolyfillTest;
    loader: PolyfillLoader;
}

class Polyfill implements IPolyfill {
    constructor(
        readonly config: {
            polyfill: string,
            test: PolyfillTest,
            loader: PolyfillLoader,
        },
    ) { }

    public test() {
        const result = this.config.test();
        // tslint:disable-next-line:no-console
        console.debug(`Testing support for "${this.config.polyfill}" ==>>`, result);
        return result;
    }

    public loader() {
        // tslint:disable-next-line:no-console
        console.debug(`Polyfilling "${this.config.polyfill}"...`);
        return this.config.loader();
    }
}

const features: Polyfill[] = [
    new Polyfill({
        polyfill: "IntersectionObserver",
        test: () => "IntersectionObserver" in window === true,
        loader: () => import("intersection-observer" as any),
    }),
    new Polyfill({
        polyfill: "Array.from()",
        test: () => "from" in Array === true,
        loader: () => import("core-js/fn/array/from" as any),
    }),
    new Polyfill({
        polyfill: "Element#remove()",
        test: () => "remove" in Element === true,
        loader: () => import("./polyfill-element-remove-prototype" as any),
    }),
    new Polyfill({
        polyfill: "Element#matches()",
        test: () => "matches" in Element === true,
        loader: () => import("./polyfill-element-matches-prototype" as any),
    }),
    new Polyfill({
        polyfill: "Element#closest()",
        test: () => "closest" in Element === true,
        loader: () => import("./polyfill-element-closest-prototype" as any),
    }),
];

export const polyfill = () => Promise.all(features.map((feature) => {
    if (feature.test() === false) {
        return feature.loader();
    } else {
        return Promise.resolve();
    }
}));



// WEBPACK FOOTER //
// ./polyfill/polyfill.ts